module.exports = __webpack_public_path__ + "img/kleisma3m-m@2.beea2c8b.jpg";